<div class="progressWrapper progressPinWrapper d-flex flex-nowrap align-items-center w-100" [class.progressPinlessWrapper]="!hasPin">
  <div class="progress w-100 my-auto" [style.height]="height">
    <div class="progress-bar{{type ? ' bg-' + type : ''}}{{animated ? ' progress-bar-animated' : ''}}{{striped ?
      ' progress-bar-striped' : ''}}" role="progressbar" [style.width.%]="getPercentValue()"
      [attr.aria-valuenow]="getValue()" aria-valuemin="0" [attr.aria-valuemax]="max">
      @if (showValue) {
        <span i18n="@@ngb.progressbar.value">{{getPercentValue()}}</span>
      }
      <ng-content></ng-content>
    </div>
  </div>
  @if (topicItem && hasPin) {
    <button class="btn progressPin p-0" tabindex="0" type="button" [class.progressPinned]="isPinned" [attr.aria-label]="label" [disabled]="!canPin" (click)="open()">
      <i class="fa fa-map-pin"></i>
    </button>
  }
</div>
